// import CryptoJS from "crypto-js";

// const deriveKeys = (passphrase, salt) => {
//   const keyMaterial = CryptoJS.PBKDF2(passphrase, salt, {
//     keySize: 16,
//     iterations: 10000,
//   });
//   const encryptionKey = CryptoJS.lib.WordArray.create(
//     keyMaterial.words.slice(0, 8),
//     32
//   );
//   const hmacKey = CryptoJS.lib.WordArray.create(
//     keyMaterial.words.slice(8, 16),
//     32
//   );
//   return { encryptionKey, hmacKey };
// };

// export const handleEncodeJson = ({ encodeJSON, passphrase = "XkhZG4fW2t2W" }) => {
//   try {
//     const data = JSON.stringify(encodeJSON);
//     const salt = CryptoJS.lib.WordArray.random(16);
//     const { encryptionKey, hmacKey } = deriveKeys(passphrase, salt);
//     const iv = CryptoJS.lib.WordArray.random(16);
//     const encrypted = CryptoJS.AES.encrypt(data, encryptionKey, {
//       iv: iv,
//       padding: CryptoJS.pad.Pkcs7,
//       mode: CryptoJS.mode.CBC,
//     });

//     const ciphertext = encrypted.ciphertext;
//     const macData = salt.clone().concat(iv).concat(ciphertext);
//     const hmac = CryptoJS.HmacSHA256(macData, hmacKey);

//     return {
//       encryptedData: ciphertext.toString(CryptoJS.enc.Hex),
//       salt: salt.toString(CryptoJS.enc.Hex),
//       iv: iv.toString(CryptoJS.enc.Hex),
//       hmac: hmac.toString(CryptoJS.enc.Hex),
//     };
//   } catch (error) {
//     console.error("Error during encryption:", error);
//     return null;
//   }
// };

// export const handleDecodeJSON = ({ decodeJSON, passphrase = "XkhZG4fW2t2W" }) => {
//   try {
//     const { salt, iv, encryptedData, hmac } = decodeJSON;

//     const saltWordArray = CryptoJS.enc.Hex.parse(salt);
//     const ivWordArray = CryptoJS.enc.Hex.parse(iv);
//     const ciphertextWordArray = CryptoJS.enc.Hex.parse(encryptedData);
//     const providedHmac = CryptoJS.enc.Hex.parse(hmac);
//     const { encryptionKey, hmacKey } = deriveKeys(passphrase, saltWordArray);
//     const macData = saltWordArray
//       .clone()
//       .concat(ivWordArray)
//       .concat(ciphertextWordArray);
//     const computedHmac = CryptoJS.HmacSHA256(macData, hmacKey);

//     if (
//       computedHmac.toString(CryptoJS.enc.Hex) !==
//       providedHmac.toString(CryptoJS.enc.Hex)
//     ) {
//       throw new Error("HMAC verification failed. Data integrity compromised.");
//     }

//     const cipherParams = CryptoJS.lib.CipherParams.create({
//       ciphertext: ciphertextWordArray,
//     });

//     const decrypted = CryptoJS.AES.decrypt(cipherParams, encryptionKey, {
//       iv: ivWordArray,
//       padding: CryptoJS.pad.Pkcs7,
//       mode: CryptoJS.mode.CBC,
//     });

//     return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
//   } catch (error) {
//     console.error("Error during decryption:", error);
//     return null;
//   }
// };

// // Example usage
// (async () => {
//   const passphrase = "MySuperSecurePassphrase@2023!";
//   const dataToEncrypt = { sensitive: "data" };

//   const encryptedResult = handleEncodeJson({
//     encodeJSON: dataToEncrypt,
//     passphrase: passphrase,
//   });


//   const decryptedData = handleDecodeJSON({
//     decodeJSON: encryptedResult,
//     passphrase: passphrase,
//   });

// })();


import CryptoJS from "crypto-js";
import { AES_IV, AES_KEY } from "./constants";

// const AES_KEY =AES_KEY ;
// const AES_IV = AES_IV;

export const handleEncodeJson = async ({ encodeJSON }) => {
  try {
    
    const data = JSON.stringify(encodeJSON);
    const wordArray = CryptoJS.enc.Utf8.parse(data);

    const key = CryptoJS.enc.Hex.parse(AES_KEY);  // Convert key to WordArray
    const iv = CryptoJS.enc.Hex.parse(AES_IV);   // Convert IV to WordArray

    const encrypted = CryptoJS.AES.encrypt(wordArray, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return {
      encryptedData: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
    };
  } catch (error) {
  }
};

export const handleDecodeJSON = async ({ decodeJSON }) => {
  try {

    
    const key = CryptoJS.enc.Hex.parse(AES_KEY);
    const iv = CryptoJS.enc.Hex.parse(AES_IV);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(decodeJSON?.encryptedData),
      },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {
  }
};